import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, CustomSelect, TextArea, TextInput } from "../../components";
import { addOrganization } from "@/store/constants/constants.action";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../store";

interface AddOrganizationFormProps {
  onClose: () => void;
}

export const AddOrgForm = ({ onClose, addOrganization }: Props) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      desc: "",
      status: 1,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Organization Name is required"),
    }),
    onSubmit: (values) => {
      //
    },
  });
  const handleSubmit = () => {
    addOrganization(formik.values);
    onClose();
  };
  return (
    <>
      <div className="mb-3">
        <TextInput
          name="name"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          showRequired={true}
          label="Title"
        />
      </div>
      <div className="mb-3">
        <TextArea
          name="desc"
          value={formik.values.desc}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Description"
          showRequired={false}
        />
      </div>
      <CustomSelect
        className="mb-3"
        value={formik.values.status}
        label="Status"
        name="status"
        options={[
          { label: "Active", value: 1 },
          { label: "Inactive", value: 2 },
        ]}
        disabled={false}
        placeholder="Select Status"
        handleChange={(newValue: any) => {
          formik.setFieldValue("status", newValue.value);
        }}
      />
      <div className="d-flex justify-content-end">
        <Button type="outline-secondary" onClick={onClose} className="me-2">
          Cancel
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Save
        </Button>
      </div>
    </>
  );
};

const mapState = (state: RootState) => ({
  organizationList: state.constants.organizationList.list,
});
const mapDispatch = {
  addOrganization,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & AddOrganizationFormProps;

export default connector(AddOrgForm);
